import React, { ReactNode } from "react";

import Dropdown, { DropdownItem } from "@common/components/Dropdown/Dropdown";
import { CellEnd, CenteredCell } from "@common/components/GridTable/GridTable";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { getIntegrationTypeName, Integration, IntegrationType } from "@common/models/integrations";
import { vars } from "@common/styles";
import identifiers from "@common/util/identifiers.json";

import * as Styled from "./UserFeedbackIntegrationsRow.styles";
import { getIntegrationTypeLogo } from "../../util/getIntegrationTypeLogo";

interface Props {
  onConnect: (type: IntegrationType) => void;
  onDisconnect: () => void;
  integration: Integration | null;
  onSettingsSelect: () => void;
  type: IntegrationType;
  showSettings?: boolean;
  tooltip: string;
  disabled: boolean;
}

export const UserFeedbackIntegrationsRow = ({
  onConnect,
  onDisconnect,
  onSettingsSelect,
  integration,
  type,
  tooltip,
  disabled,
}: Props) => {
  const TooltipWrap = ({ children }: { children: ReactNode }) => {
    return tooltip && disabled ? (
      <Styled.Tooltip
        position="top"
        text={tooltip}
      >
        {children}
      </Styled.Tooltip>
    ) : (
      <>{children}</>
    );
  };
  const DropdownButton = () => {
    return (
      <CellEnd>
        <TooltipWrap>
          <Dropdown
            testId={identifiers["integrations.icon.options"]}
            disabled={disabled}
            numTooltipText={tooltip}
          >
            {integration && integration.active ? (
              <>
                <DropdownItem
                  onClick={onSettingsSelect}
                  testId={identifiers["integrations.icon.dropdown.settings"]}
                >
                  <span>Settings</span>
                </DropdownItem>
                <DropdownItem
                  onClick={() => onDisconnect()}
                  testId={identifiers["integrations.icon.dropdown.disconnect"]}
                  error
                >
                  Disconnect
                </DropdownItem>
              </>
            ) : (
              <DropdownItem
                onClick={() => onConnect(type)}
                testId={identifiers["integrations.icon.dropdown.connect"]}
                disabled={disabled}
              >
                {"Connect"}
              </DropdownItem>
            )}
          </Dropdown>
        </TooltipWrap>
      </CellEnd>
    );
  };

  return (
    <>
      <CenteredCell gap={16}>
        <Styled.Logo
          src={getIntegrationTypeLogo(type)}
          alt="Integration Logo"
        />

        <Paragraph color={vars.colors.grey30}>{getIntegrationTypeName(type)}</Paragraph>
      </CenteredCell>
      <CenteredCell>
        {integration && integration.active ? (
          <>
            <Styled.ConnectedIcon />
            <Styled.Connected>Connected</Styled.Connected>
          </>
        ) : (
          <>
            <Styled.DisconnectedIcon />
            <Styled.Disconnected>Not connected</Styled.Disconnected>
          </>
        )}
      </CenteredCell>
      <DropdownButton />
    </>
  );
};
